import { Launch as LaunchIcon } from "@mui/icons-material";
import { Avatar, Grid, IconButton, List, ListItem, ListItemAvatar, ListItemText, Typography } from "@mui/material";
import type { FC } from "react";
import { useEffect, useState } from "react";
import { storageUrlWithCredentials } from "../components/imagesPreview/storageUrlWithCredentials";
import type { PackageCustomerResponse } from "./publicPackagesApi";

function stringToColor(string: string) {
  let hash = 0;

  for (let i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (let i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  return color;
}

function stringAvatar(name: string) {
  return {
    sx: {
      bgcolor: stringToColor(name),
    },
    children: name
      .split(" ")
      .slice(0, 2)
      .map((i) => i[0].toUpperCase())
      .join(""),
  };
}

const PackageCustomer: FC<{ customer: PackageCustomerResponse }> = ({ customer }) => {
  const [logoSignedUrl, setLogoSignedUrl] = useState<string>();
  useEffect(() => {
    if (customer.logo?.url) {
      storageUrlWithCredentials(customer.logo.url).then((url) => setLogoSignedUrl(url));
    } else {
      setLogoSignedUrl(undefined);
    }
  }, [customer.logo?.url]);
  return (
    <ListItem
      data-testid="package-customer-row"
      secondaryAction={
        <IconButton edge="end" aria-label="Zobacz ofertę" onClick={() => window.open(customer.link, "_blank")}>
          <LaunchIcon />
        </IconButton>
      }
    >
      <ListItemAvatar>
        {customer.logo ? (
          <Avatar alt={customer.logo.name} src={logoSignedUrl} />
        ) : (
          <Avatar {...stringAvatar(customer.name)} />
        )}
      </ListItemAvatar>
      <ListItemText primary={customer.name} secondary={customer.description} />
    </ListItem>
  );
};

interface Props {
  customers: PackageCustomerResponse[];
}

const PublicPackageCustomers: FC<Props> = ({ customers }) => (
  <Grid size={12} container spacing={2}>
    <Grid size={12}>
      <Typography variant="h6">Ten pakiet jest oferowany przez</Typography>
    </Grid>
    <Grid size={12}>
      <List sx={{ width: "100%", bgcolor: "background.paper" }}>
        {customers.map((c, idx) => (
          <PackageCustomer key={idx} customer={c} />
        ))}
      </List>
    </Grid>
  </Grid>
);

export default PublicPackageCustomers;
